// Hooks React Query para solicitudes del portal cliente

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { clienteSolicitudesService } from '@/services/clienteSolicitudesService';
import type { ExpedienteSolicitudRead, ExpedienteSolicitudUpdate } from '@/types/expedienteSolicitud';

const KEY_PENDIENTES = 'cliente-solicitudes-pendientes';
const KEY_TODAS = 'cliente-solicitudes-todas';

/** Solicitudes pendientes del cliente */
export function useClienteSolicitudesPendientes() {
  return useQuery<ExpedienteSolicitudRead[]>({
    queryKey: [KEY_PENDIENTES],
    queryFn: () => clienteSolicitudesService.getPendientes(),
    staleTime: 30_000,
  });
}

/** Todas las solicitudes del cliente */
export function useClienteSolicitudesAll() {
  return useQuery<ExpedienteSolicitudRead[]>({
    queryKey: [KEY_TODAS],
    queryFn: () => clienteSolicitudesService.getMisSolicitudes(),
    staleTime: 30_000,
  });
}

/** Responder a una solicitud */
export function useResponderSolicitud() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      expedienteId,
      solicitudId,
      data,
    }: {
      expedienteId: string;
      solicitudId: string;
      data: ExpedienteSolicitudUpdate;
    }) => clienteSolicitudesService.responder(expedienteId, solicitudId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [KEY_PENDIENTES] });
      queryClient.invalidateQueries({ queryKey: [KEY_TODAS] });
    },
  });
}

/** Count de pendientes para badge */
export function useClienteSolicitudesCount() {
  const query = useClienteSolicitudesPendientes();
  return {
    count: query.data?.length ?? 0,
    isLoading: query.isLoading,
  };
}
